<div tiptapDraggable [ngClass]="{ editable: isEditable, selected: isEditable && selected() }">
    <p>You are registered for the Diamondship Webinar.</p>
    <p>You can join by clicking <a href="#">https://zoom.us/j/1234567890?pwd=abc123</a></p>
</div>
